<!--
 * @Author: chenyn 1826650603@qq.com
 * @Date: 2023-09-25 16:40:07
 * @LastEditors: chenyn 1826650603@qq.com
 * @LastEditTime: 2023-09-25 16:40:40
 * @FilePath: \smart-campus-platform-front-vue\src\views\homepage\map\components\progress.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="progress-box">
      <!-- 进度条底层 -->
      <div class="progress-bottom">
          <!-- 进度条实际 -->
          <div class="progress"
              :style="{ width: percentage + '%', background: 'linear-gradient(180deg,' + startColor + ' 0%, ' + endColor + ' 100%)' }">
          </div>
      </div>
      <!-- 实际进度条占比 -->
      <div class="percentage" v-if="isShowText"> {{ percentage }} % </div>
      <!-- 如果是投票模式，显示投票总数 -->
      <div v-if="explain">{{ explain }}</div>
  </div>
</template>

<script>
export default {
  props: {
      isShowText: {
          type: Boolean,
          default: false
      },
      // 进度条占比
      percentage: {
          type: Number,
          default: 0
      },
      // 如果是投票模式，已投得票数
      explain: {
          type: [Number, String],
          default: '0票'
      },
      // 进度条占比的颜色设置
      percentBackground: {
          type: String,
          default: null
      },
      startColor: {
          type: String,
          default: '#d4f8ff'
      },
      endColor: {
          type: String,
          default: '#00E7FF'
      }
  },
  data() {
      return {

      };
  }
}
</script>

<style scoped lang="scss">
.progress-box {
  display: flex;

  // 进度条底层样式
  .progress-bottom {
      height:20px;
      width: 100%;
      background: #d7efff;
      border-radius: 24px;
      border: 4px solid;

      // 进度条占比样式
      .progress {
          // height: 16upx;
          // border-radius: 20upx;
          height: 20px;
          // box-shadow: 0px 1px 4px 0px rgba(0, 231, 255, 0.5);
          border-radius: 12px;
      }
  }

  // 已占比的进度条样式
  .percentage {
      margin: 0 4%;
  }
}</style>
